import BaseStore from './BaseStore'

export class WorkflowStore extends BaseStore {
  constructor() {
    super()
    this.endpoint = 'workflow_migrations'
  }
}

export default new WorkflowStore()


// WEBPACK FOOTER //
// ./src/stores/WorkflowMigrationStore.js